import * as PIXI from "pixi.js";
import gsap from 'gsap';


export default class Triangle {
    constructor(graphics, isFirst) {
        this.graphics = graphics;
        this.isFirst = isFirst;
        this.isSp = true;

        this.pos = {};
        this.wait = 0;
        this.isTween = false;
        this.centerX = this.centerY = 0;
        this.radius = 0;

        this._setBp();
        this._init();
    }

    set _wait(num) {
        this.wait = this.isFirst ? num : this.wait;
    }

    update() {
        if (this.wait <= 0) {
            if (!this.isTween) {
                this._break();
                this.isTween = true;
            }

            this._updatePos();
            this._draw();
        } else {
            this.wait--;
        }
    }



    _init() {
        this.wait = this.isFirst
            ? Math.floor(Math.random() * 10) + 50
            : Math.floor(Math.random() * 30) + 150;
        this._createPos();
    }

    _setBp() {
        const mediaQuery = window.matchMedia("(max-width: 1025px)");
        // イベントリスナーを登録

        mediaQuery.addListener((e) => {
            this._handleTabletChange(e);
        });

        this._handleTabletChange(mediaQuery);
    }

    _handleTabletChange(e) {
        if (e.matches) {
            this.isSp = true;
            //console.log(this.isSp);
        } else {
            this.isSp = false;
            //console.log(this.isSp);
        }
    }

    _createPos() {
        // 三角形のサイズ
        this.radius = this.isFirst ? 15 : 45;

        // 三角形の中心座標
        const widthw = window.innerWidth;
        const heightw = window.innerHeight;
        this.centerX = this.isFirst
            ? Math.floor(Math.random() * (widthw * 0.75 - widthw * 0.25)) +
              widthw * 0.25
            : Math.random() * widthw;
        this.centerY = this.isFirst
            ? Math.floor(Math.random() * (heightw * 0.75 - heightw * 0.25)) +
              heightw * 0.25
            : Math.random() * heightw;

        // 三角形のポイント座標生成
        this.pos = this._getRandom3PointsOnCircle();
    }

    _break() {
        // 遅延時間
        const d = Math.random() * 1;

        // アニメーション秒数
        const t = this.isFirst ? 3 : 5;

        // 三角形の大きくなる係数
        const addRadiusK = this.isFirst ? 0.05 : 0.3;

        // 三角形の割れるアニメーション
        gsap.to(this, {
            duration: t,
            delay: d,
            //scale: "+=20",
            radius: `+=${window.innerWidth * addRadiusK}`,
            ease: "power2.easeIn",
        });

        // 初期三角形の後追いアニメーション
        if (this.isFirst) {
            const degreenum = Math.random() * 100;

            if (this.isSp) {
               
                gsap.to(this, {
                    duration: 8,
                    delay: 1.8,
                    radius: `+=${window.innerWidth * 0.15}`,
                    ease: "Expo.easeOut",
                });
            } else {
                
                gsap.to(this, {
                    duration: 8,
                    delay: 1.8,
                    radius: `+=${window.innerWidth * 0.05}`,
                    ease: "Expo.easeOut",
                });
            }
            
            // ラジアン値の更新
            gsap.to(this.pos[0], {
                duration: t,
                delay: d,
                degree: `+=${degreenum}`,
                ease: "Expo.easeOut",
            });
            gsap.to(this.pos[1], {
                duration: t,
                delay: d,
                degree: `+=${degreenum}`,
                ease: "Expo.easeOut",
            });
            gsap.to(this.pos[2], {
                duration: t,
                delay: d,
                degree: `+=${degreenum}`,
                ease: "Expo.easeOut",
            });
        }

        // ラジアン値の更新(三角形を回す)
        gsap.to(this.pos[0], {
            duration: t,
            delay: d,
            degree: "+=10",
            ease: "power2.easeIn",
        });
        gsap.to(this.pos[1], {
            duration: t,
            delay: d,
            degree: "+=10",
            ease: "power2.easeIn",
        });
        gsap.to(this.pos[2], {
            duration: t,
            delay: d,
            degree: "+=10",
            ease: "power2.easeIn",
        });
    }


    _updatePos() {
        for (let i = 0; i < this.pos.length; i++) {
            const point = this._getPoint(this.pos[i].degree);
            this.pos[i].x = point.x;
            this.pos[i].y = point.y;
        }
    }

    _draw() {
        this.graphics.beginFill(0xffffff);
        this.graphics.moveTo(this.pos[0].x, this.pos[0].y);
        this.graphics.lineTo(this.pos[1].x, this.pos[1].y);
        this.graphics.lineTo(this.pos[2].x, this.pos[2].y);
        this.graphics.lineTo(this.pos[0].x, this.pos[0].y);
        this.graphics.endFill();
    }

    _getRandom3PointsOnCircle() {
        const result = [];

        // 不等辺三角形
        for (let i = 0; i < 3; i++) {
            const degree = Math.floor(Math.random() * 360);
            /* const degree = this.isFirst
                ? Math.floor(Math.random() * (360 - 270)) + 270
                : Math.floor(Math.random() * 360); */

            if (this.isFirst) {
                if (i === 0) {
                    const degree = 135;
                    const point = this._getPoint(degree);
                    result.push({ x: point.x, y: point.y, degree: degree });
                } else if (i === 1) {
                    const degree = 270;
                    const point = this._getPoint(degree);
                    result.push({ x: point.x, y: point.y, degree: degree });
                } else if (i === 2) {
                    const degree = 300;
                    const point = this._getPoint(degree);
                    result.push({ x: point.x, y: point.y, degree: degree });
                }
            }

            const point = this._getPoint(degree);
            result.push({ x: point.x, y: point.y, degree: degree });
        }
        return result;

        /*
        // 二等辺三角形
        const degree = Math.max(50, Math.floor(Math.random() * 90));
        return this._getNitohenPoint(90);
        */
    }

    _getPoint(degree) {
        const radian = (degree * Math.PI) / 180;
        const x = Math.floor(this.centerX + Math.cos(radian) * this.radius);
        const y = Math.floor(this.centerY + Math.sin(radian) * this.radius);
        return { x: x, y: y };
    }

    /**
     * 二等辺三角形のポイントを作成する
     */
    _getNitohenPoint(degree = 90) {
        const x1 = this.centerX + Math.cos(-90) * this.radius;
        const y1 = this.centerY + Math.sin(-90) * this.radius;
        const x2 = this.centerX + Math.cos(-90 + degree) * this.radius;
        const y2 = this.centerY + Math.sin(-90 + degree) * this.radius;
        const x3 = this.centerX + Math.cos(-90 - degree) * this.radius;
        const y3 = this.centerY + Math.sin(-90 - degree) * this.radius;
        return [
            { x: x1, y: y1, degree: -90 },
            { x: x2, y: y2, degree: -90 + degree },
            { x: x3, y: y3, degree: -90 - degree },
        ];
    }
}